module.exports = __webpack_public_path__ + "static/media/charity-default-cover.a04b1258.jpg";